var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bas-dropdown",
    class: {
      collapsed: _vm.collapsed
    }
  }, [_vm.label ? _c('div', {
    staticClass: "label"
  }, [_c('span', [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")])]) : _vm._e(), _c('div', {
    staticClass: "dropdown-container"
  }, [_c('div', {
    staticClass: "header",
    on: {
      "click": _vm.onDropDownClick
    }
  }, [_vm.selection ? _c('div', {
    staticClass: "selection-overlay"
  }, [_c('span', [_vm._v(_vm._s(_vm.selection))])]) : _vm._e(), _c('div', {
    staticClass: "left"
  }), _vm._m(0)]), _vm.collapsed ? _c('div', {
    staticClass: "options-container"
  }, _vm._l(_vm.options, function (option, index) {
    return _c('div', {
      key: index,
      staticClass: "option",
      on: {
        "click": function ($event) {
          return _vm.handleSelection(option.label ? option.label : option);
        }
      }
    }, [_vm._v("\n        " + _vm._s(option.label ? option.label : option) + "\n      ")]);
  }), 0) : _vm._e()])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "arrow-down"
  })]);
}]

export { render, staticRenderFns }